<div class="relative w-full max-w-[480px] bg-white border-4 border-[var(--black)] rounded-2xl shadow-2xl overflow-hidden">
  <div class="h-2 bg-[var(--secondary)]"></div>
  <div class="px-8 pt-7 pb-8 flex flex-col items-center text-center gap-4">
    <div class="w-16 h-16 rounded-full bg-[var(--light-grey)] border-4 border-[var(--black)] flex items-center justify-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 512 512" fill="var(--black)">
        <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
      </svg>
    </div>
    <div>
      <h2 class="text-[26px] font-bold uppercase text-[var(--black)] leading-tight mb-2">
        {{ 'emailVerificationModal.title' | translate }}
      </h2>
      <p class="text-[15px] text-[var(--dark-grey)] leading-relaxed mb-1">
        {{ 'emailVerificationModal.sent' | translate }}
      </p>
      <p class="text-[15px] font-semibold text-[var(--black)] mb-3">
        {{data.email}}
      </p>
      <p class="text-[13px] text-[var(--dark-grey)] leading-snug">
        {{ 'emailVerificationModal.checkInbox' | translate }}<br>
        {{ 'emailVerificationModal.checkSpam' | translate }}
      </p>
    </div>
    <div class="flex flex-col gap-3 w-full mt-2">
      <button (click)="closeModal()"
        class="w-full py-3 rounded-xl bg-[var(--secondary)] text-white font-bold uppercase text-[13px] tracking-wide hover:opacity-80 transition-opacity">
        {{ 'emailVerificationModal.understood' | translate }}
      </button>
    </div>
  </div>
</div>
